import { IDO_ACTIVITY_HISTORY_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE } from 'src/stores/idoActivityHistoryList/localStorageKeys';
import { TSMap } from 'typescript-map';

import { Activity } from 'src/models/activity';
import { DateRangeSelection } from 'src/models/common';
import { FilterBoxes, FilterUsers } from 'src/models/filter';
import {
	ActivityListTypeEnum,
	GenericActivityListPagination,
	GenericActivityListSort,
} from 'src/models/genericActivityList';
import { SerializedQuery } from 'src/models/query';

import type { IdoRelationFilterEntry } from './types';

interface IdoActivityHistoryListStateInterface {
	activeQueryIdentifierByKey: Map<string, string>;
	dateFilter: Map<string, DateRangeSelection | string | string[]>;
	directionFilter: Map<string, 'combined' | 'in' | 'out'>;
	fetchingKeys: Set<string>;
	filterBoxes: Map<string, Array<FilterBoxes>>;
	filterUsers: Map<string, Array<FilterUsers>>;
	filteredBoxIds: Map<string, Array<string>>;
	filteredUsers: Map<string, Array<FilterUsers>>;
	idoActivityHistoryList: Map<string, Array<Activity>>;
	idoActivityHistoryListSliced: Map<string, Map<number, Array<Activity>>>;
	idoActivityHistoryListTotalCount: Map<string, number>;
	idoRelationsFilter: Map<string, Array<IdoRelationFilterEntry>>;
	listViewModeLarge: boolean;
	loadedKeys: Set<string>;
	pagination: TSMap<string, GenericActivityListPagination>;
	queryStoreSubscriptions: Map<string, SerializedQuery>;
	searchTerm: Map<string, string>;
	sort: TSMap<string, GenericActivityListSort>;
	view: Map<string, 'all' | 'open'>;
}

function state(): IdoActivityHistoryListStateInterface {
	return {
		activeQueryIdentifierByKey: new Map<string, string>(),
		dateFilter: new Map<string, DateRangeSelection | string | string[]>(),
		directionFilter: new Map<string, 'combined' | 'in' | 'out'>(),
		fetchingKeys: new Set<string>(),
		filterBoxes: new Map<string, Array<FilterBoxes>>(),
		filterUsers: new Map<string, Array<FilterUsers>>(),
		filteredBoxIds: new Map<string, Array<string>>(),
		filteredUsers: new Map<string, Array<FilterUsers>>(),
		idoActivityHistoryList: new Map<string, Array<Activity>>(),
		idoActivityHistoryListSliced: new Map<string, Map<number, Array<Activity>>>(),
		idoActivityHistoryListTotalCount: new Map<string, number>(),
		idoRelationsFilter: new Map<string, Array<IdoRelationFilterEntry>>(),
		listViewModeLarge:
			localStorage.getItem(IDO_ACTIVITY_HISTORY_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(
						localStorage.getItem(IDO_ACTIVITY_HISTORY_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) as
							| 'false'
							| 'true'
					)
				: true,
		loadedKeys: new Set<string>(),
		pagination: new TSMap<string, GenericActivityListPagination>(),
		queryStoreSubscriptions: new Map<string, SerializedQuery>(),
		searchTerm: new Map<string, string>(),
		sort: new TSMap<ActivityListTypeEnum, GenericActivityListSort>(),
		view: new Map<string, 'all' | 'open'>(),
	};
}

export default state;
